module.exports = __webpack_public_path__ + "img/ico-yorumlar.998def05.svg";